module.exports = __webpack_public_path__ + "media/app/assets/specializations/druid/balance-b2371a9c730222517c8d89735387b626.png";